<template>
  <div>      
    <component v-if="showLoadingPlaceholder"
      :is="loadingPlaceholder || 'default-loading-placeholder'" 
    ></component>
    <slot v-else></slot>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import DefaultLP from '@/LoadingPlaceholders/DefaultLP';
export default {
  name: 'loading-view-placeholder',
  components: {
    'default-loading-placeholder': DefaultLP
  },
  computed: {
    ...mapState({
      routing: state => state.ui.routing,
      isMobileView: state => state.ui.isMobileView,
      showMapOnMobile: state => state.ui.showMapOnMobile,
      mobileHeaderShow: state => state.ui.mobileHeader,
      loadingPlaceholder: state => state.ui.pageLoadingPlaceholder
    }),
    showLoadingPlaceholder: function() {
      return this.routing && !this.showMapOnMobile && this.loadingPlaceholder;
    }
  },
}
</script>
